export const apiBase = () => {
	if (window.location.origin.includes("localhost"))
		return "http://localhost:3000";
	if (window.location.origin.includes("192"))
		return "https://192.168.1.111:3000";

	return "https://waitsfieldpta.fly.dev";
};

export const processingFee = 2.96 / 100;

export const privileged = ["admin", "staff"];

export const allowed = [
	"awerntgen@gmail.com",
	"waitsfieldelementarypta@gmail.com",
	"seaverme@gmail.com",
	"daniellelillard@gmail.com",
	"ctylerusa@aol.com",
	"joannebickford@gmail.com",
	"heftstudio@gmail.com",
	"gmcb802@outlook.com",
	"jasper.mayone.skiskate@gmail.com",
	"jasper.mayone.skiskate+consignor@gmail.com",
	"eben.goodman+admin@gmail.com",
];
